/** @todo Fix import cycle */
/* eslint-disable import/no-cycle */

import * as Sentry from '@sentry/browser'
import { action } from 'mobx'
import { createContext } from 'react'

// Stores
import { refreshAccessToken as refreshAccessTokenService } from '../services/user.service'
import { clientDashboard } from './ClientDashboardStore'
import { dashboard } from './DashboardStore'
import { tasks } from './TaskStore'
import { user } from './UserStore'
import { users } from './UsersStore'

export class RootStore {
  user = user

  users = users

  dashboard = dashboard

  tasks = tasks

  clientDashboard = clientDashboard

  clearStore = action(() => {
    this.dashboard.reset()
    this.tasks.reset()
    this.user.reset()
    this.users.reset()
    this.clientDashboard.reset()

    Sentry.setUser(null)
  })

  triggerRefreshToken = action(async (failedRequest) => {
    try {
      const { access, refresh } = await refreshAccessTokenService(this.user.refreshToken)
      this.user.accessToken = access
      this.user.refreshToken = refresh
      // Reassign to `failedRequest` as this object is used by the token
      // interceptor to retry the request
      // eslint-disable-next-line no-param-reassign
      failedRequest.response.config.headers.Authorization = `Bearer ${access}`
    } catch (err) {
      this.clearStore()
      throw err
    }
  })
}

export const store = new RootStore()
export const RootStoreContext = createContext(store)
